import React, { useRef, useState } from 'react'
import '../../css/bootstrap.scss'
import './login.scss'
import { Link, useNavigate } from 'react-router-dom'
import { login } from '../../Api';
import Swal from 'sweetalert2';
import { useRole } from '../../RoleContext';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';

const VideoComponent = ({ videoUrl, imageUrl, isPlaying, setIsPlaying }) => {
    const videoRef = useRef(null);
    return (
        <div className='main-video-sec w-100'>
            <div className={isPlaying ? 'd-none' : "video-image-div pointer"}>
                <img src={imageUrl} alt="" className='play-button' onClick={() => {
                    setIsPlaying(true)
                    if (videoRef.current) {
                        videoRef.current.play()
                    }
                }} />
            </div>
            <div className={!isPlaying ? 'd-none' : 'video-div w-100'}>
                <video className="responsive-video"
                    ref={videoRef}
                    controls
                    disablePictureInPicture
                    muted
                    autoPlay
                    src={videoUrl}
                    onClick={() => {
                        if (!isPlaying) {
                            setIsPlaying(true); videoRef.current.play()
                        } else {
                            setIsPlaying(false); videoRef.current.pause()
                        }
                    }}
                    controlsList='noplaybackrate nodownload'
                    // onMouseEnter={() => {setIsPlaying(true); videoRef.current.play()}}
                    // onMouseLeave={() => {if(isPlaying === true){ setIsPlaying(false); videoRef.current.pause()} else{ setIsPlaying(true); videoRef.current.play()} }} 
                    // onPause={() => { setIsPlaying(false) }} 
                    onEnded={() => { setIsPlaying(false) }}
                ></video>
            </div>
        </div>
    )
}

function Login() {
    const { role, setRole } = useRole()
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isPlaying, setIsPlaying] = useState(true);

    const handleSubmit = async () => {
        Swal.fire({
            html: `<img src='/circle-1700_256.gif' style="height: 60px" alt="" />`,
            customClass: { popup: 'loader' },
            showConfirmButton: false,
            heightAuto: false
        })
        let emalval = new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$');
        if (!email) {
            Swal.fire({
                text: 'Email required!',
                icon: 'warning',
                iconColor: '#000',
                showConfirmButton: false,
                heightAuto: false,
                timer: 1500
            });
        } else if (!emalval.test(email)) {
            Swal.fire({
                text: 'Please enter valid Email',
                icon: 'warning',
                iconColor: '#000',
                showConfirmButton: false,
                heightAuto: false,
                timer: 1500
            });
        } else if (!password) {
            Swal.fire({
                text: 'Password required!',
                icon: 'warning',
                iconColor: '#000',
                showConfirmButton: false,
                heightAuto: false,
                timer: 1500
            });
        } else {
            let data = {
                email: email.toLowerCase(),
                password
            }
            let apiRes = await login(data);
            console.log(apiRes)
            if (apiRes.status === "S") {
                Swal.close();
                if (apiRes.role === 1) {
                    localStorage.clear();
                    Swal.fire({
                        text: 'Invalid Credentials',
                        icon: 'warning',
                        iconColor: '#000',
                        showConfirmButton: false,
                        heightAuto: false,
                        timer: 1500
                    })
                }else{
                    localStorage.setItem('role', apiRes.role);
                    setRole(apiRes.role);
                    localStorage.setItem('correl_id', apiRes.correl_id);
                    localStorage.setItem('userData', JSON.stringify(apiRes.result_info));
                    if (apiRes.is_first_time_login === 'Y') {
                        navigate('/change-password');
                    } else {
                        if (apiRes.result_info.google_refresh_token) {
                            navigate('/dashboard');
                            localStorage.setItem('refreshToken', apiRes.result_info.google_refresh_token);
                            localStorage.setItem('accessToken', apiRes.result_info.google_access_token);
                            localStorage.setItem('idToken', apiRes.result_info.google_id_token);
                            localStorage.setItem('user', JSON.stringify({sub: apiRes.result_info.google_user_sub}));
                        } else {
                            localStorage.removeItem('refreshToken');
                            localStorage.removeItem('accessToken');
                            localStorage.removeItem('idToken');
                            localStorage.removeItem('user');
                            navigate('/connect-google', { state: { email: email } });
                        }
                    }
                }
            } else if (apiRes.status === 'E' && apiRes.result_code === 404) {
                Swal.fire({
                    text: 'Invalid Credentials',
                    icon: 'warning',
                    iconColor: '#000',
                    showConfirmButton: false,
                    heightAuto: false,
                    timer: 1500
                })
            } else if (apiRes.status === 'E' && apiRes.result_code === 401) {
                Swal.fire({
                    text: 'Invalid Credentials',
                    icon: 'warning',
                    iconColor: '#000',
                    showConfirmButton: false,
                    heightAuto: false,
                    timer: 1500
                })
            } else if (apiRes.status === 'E' && apiRes.result_code === 202) {
                Swal.fire({
                    text: apiRes.message,
                    icon: 'warning',
                    iconColor: '#000',
                    showConfirmButton: false,
                    heightAuto: false,
                    timer: 1500
                })
            } else {
                // Swal.fire({
                //     text: JSON.stringify(apiRes.error),
                //     icon: 'warning',
                //     iconColor: '#000',
                //     showConfirmButton: false,
                //     heightAuto: false,
                //     timer: 1500
                // })
                Swal.fire({
                    text: 'Server Error',
                    icon: 'warning',
                    iconColor: '#000',
                    showConfirmButton: false,
                    heightAuto: false,
                    timer: 1500
                })
            }
        }
    }
    const handleKeyDown = (ev) => {
        if (ev.key === "Enter") {
            ev.preventDefault();
            handleSubmit();
        }
    };
    return (<>
        <div className='bootstrap-content weblogin-page' key={'role-' + role}>
            <div className="row g-0 w-100 h-100" >
                <div className="col-6 d-none d-lg-block">
                    <div className="login-left">
                        <div className="ellipse"></div>

                        <h6 className='login-page-subheading'>Your Gateway to Growth</h6>
                        <h6 className='login-page-heading'>Log In to Your Good Reviews Account!</h6>
                        <div className={isPlaying ? "login-bg-color no-bg-img" : "login-bg-color"}>
                            <div className="image-container w-100">
                                <VideoComponent isPlaying={isPlaying} setIsPlaying={setIsPlaying} videoUrl={require('../../assets/gr-login-video.mp4')} imageUrl={require('../../assets/play-button.png')} />
                            </div>
                        </div>
                        <h6 className='login-desc mt-2s'>Trusted By 10,000+ Global Companies of all sizes</h6>
                        <div className="row justify-content-center">
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/aws.png')} alt="" className='logos' />
                            </div>
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/microsoft.png')} alt="" className='logos' />
                            </div>
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/google-partner.png')} alt="" className='logos' />
                            </div>
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/katalon.png')} alt="" className='logos' />
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/partner.png')} alt="" className='logos' />
                            </div>
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/ware.png')} alt="" className='logos' />
                            </div>
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/citrix.png')} alt="" className='logos' />
                            </div>
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/salesforce.png')} alt="" className='logos' />
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/norton.png')} alt="" className='logos' />
                            </div>
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/symantec.png')} alt="" className='logos' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-lg-6 h-100">
                    <div className="login-right">
                        <div className="login-card">
                            <div className="text-center">
                                <img src={require("../../assets/logo.png")} alt="" className='logo-image pointer' onClick={() => { navigate('/') }} />
                                <h6 className='login-welcometext'>Welcome to Good Reviews</h6>
                            </div>
                            <div className="text-start">
                                <div className="mb-3 text-start">
                                    <label for="exampleInputEmail1" className="form-label">Email</label>
                                    <input type="text"
                                        name="Admin_Email"
                                        className="form-control"
                                        aria-describedby="adminEmail"
                                        placeholder='Enter your Email'
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        autoComplete='goodreviews'
                                    />
                                </div>
                                <div className="mb-3 text-start">
                                    <label for="exampleInputPassword1" className="form-label">Password</label>
                                    <div className="d-flex justify-content-between align-items-center pos-rel">
                                        <input type={(password === '' || showPassword) ? "text" : "password"}
                                            name="Admin_Password"
                                            className="form-control input-with-icon"
                                            aria-describedby="adminPassword"
                                            placeholder='Enter your Password'
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            autoComplete='goodreviews'
                                            onKeyDown={handleKeyDown}
                                        />
                                        <span
                                            className="input-icon eye-icon"
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            {showPassword ? <MdVisibility /> : <MdVisibilityOff />}
                                        </span>
                                    </div>

                                </div>
                                <button className='text-center btn btn-black' onClick={() => { handleSubmit() }}>
                                    Login
                                </button>
                            </div>
                            <div className='d-flex justify-content-between'>
                                <Link to='https://goodreviews.co/pricing.html' className='text-decoration-none text-black me-3'>
                                    <h6 className='bottom-text'>
                                        Create Account
                                    </h6>
                                </Link>
                                <Link to='/forgot-password' className='text-decoration-none text-black me-3'>
                                    <h6 className='bottom-text'>
                                        Forgot Password
                                    </h6>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    </>)
}

export default Login